import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Mail } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-navy text-white pt-16 pb-8" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-74">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-1" data-id="element-75">
            <Link to="/" className="inline-block mb-6" data-id="element-76">
              <span className="text-2xl font-black tracking-tighter text-white" data-id="element-77">
                RE<span className="text-brand-magenta" data-id="element-78">GROWTH</span>
              </span>
            </Link>
            <p className="text-gray-300 text-sm leading-relaxed mb-6" data-id="element-79">
              Fat liberation learning and publishing rooted in anti-oppression
              politics.
            </p>
            <div className="flex space-x-4" data-id="element-80">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-81">
                <Instagram className="h-5 w-5" data-id="element-82" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-83">
                <Twitter className="h-5 w-5" data-id="element-84" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-85">
                <Mail className="h-5 w-5" data-id="element-86" />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div data-id="element-87">
            <h3 className="text-brand-lime font-bold uppercase tracking-wider text-sm mb-6" data-id="element-88">
              Learn
            </h3>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-89">
              <li data-id="element-90">
                <Link to="/clusters/courses" className="hover:text-white transition-colors" data-id="element-91">
                  Courses
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/clusters/ways-to-learn" className="hover:text-white transition-colors" data-id="element-93">
                  Ways to Learn
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/clusters/systems-power" className="hover:text-white transition-colors" data-id="element-95">
                  Our Framework
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-96">
            <h3 className="text-brand-cyan font-bold uppercase tracking-wider text-sm mb-6" data-id="element-97">
              Read
            </h3>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-98">
              <li data-id="element-99">
                <Link to="/blog" className="hover:text-white transition-colors" data-id="element-100">
                  The Blog
                </Link>
              </li>
              <li data-id="element-101">
                <Link to="/publication" className="hover:text-white transition-colors" data-id="element-102">
                  The Publication
                </Link>
              </li>
              <li data-id="element-103">
                <Link to="/clusters/contribute" className="hover:text-white transition-colors" data-id="element-104">
                  Submit Work
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-105">
            <h3 className="text-brand-orange font-bold uppercase tracking-wider text-sm mb-6" data-id="element-106">
              Connect
            </h3>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-107">
              <li data-id="element-108">
                <Link to="/about" className="hover:text-white transition-colors" data-id="element-109">
                  About
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/contact" className="hover:text-white transition-colors" data-id="element-111">
                  Contact
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/accessibility" className="hover:text-white transition-colors" data-id="element-113">
                  Accessibility
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-114">
          <div className="mb-4 md:mb-0" data-id="element-115">
            &copy; {currentYear} REGROWTH. ALL POWER TO FAT PEOPLE.
          </div>
          <div className="flex space-x-6" data-id="element-116">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-117">
              PRIVACY
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-118">
              TERMS
            </Link>
            <Link to="/values" className="hover:text-white transition-colors" data-id="element-119">
              VALUES
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}